import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import { DentalService } from "../../../interfaces/AssessmentInterfaces";

interface PropType {
  onChange: (v: Array<string>) => void;
  options: Array<string>;
  item: DentalService;
}

// eslint-disable-next-line import/prefer-default-export
export const TeethSelector = ({ onChange, options, item }: PropType): React.JSX.Element => (
  <Autocomplete
    multiple
    disabled={!options.length}
    options={options}
    value={item.teeth}
    disableClearable
    onChange={(_, newValue) => onChange(newValue)}
    renderTags={(value: string[], getTagProps) =>
      value.map((option: string, index: number) => (
        <Chip
          {...getTagProps({ index })}
          key={option}
          label={option}
          size="small"
          sx={{
            maxWidth: 100,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        />
      ))
    }
    renderInput={(params) => (
      <TextField
        {...params}
        fullWidth
        placeholder="Select teeth..."
        variant="outlined"
        slotProps={{ inputLabel: { shrink: true } }}
      />
    )}
  />
);
